import { render, staticRenderFns } from "./chaoslist.vue?vue&type=template&id=0bd04e12&scoped=true&"
import script from "./chaoslist.vue?vue&type=script&lang=js&"
export * from "./chaoslist.vue?vue&type=script&lang=js&"
import style0 from "./chaoslist.vue?vue&type=style&index=0&id=0bd04e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd04e12",
  null
  
)

export default component.exports